import React from 'react'
import { EXPORT_PPT } from '../../constants'
import { useGlobalStore } from '../../store'
import { OuterWrapper } from './style'


const ReportOuterWrapper = ({ children, id, style, type, insightsId }) => {
  const { isCSVModalActive, isPPTModalActive } = useGlobalStore()

  // NOTE: CONFIGURATION FOR GENERATING NATIVE PPT.
  const array = [
    'BusinessObjective', 'ResearchDesign', 'CompetitiveLandscape', 'CompetitiveLandscapeBrandImagery', 'SegmentOverview', 'SegmentProgressionOverview', 'SegmentOfSegmentOverviewAndProgression', 'SegmentAndSegmentProgression', 'AllRelativeBrandsAnalysis', 'SegmentAndSegmentOfSegment', 'FactorInterlinkage', ...EXPORT_PPT.deepDiveDrivers, ...EXPORT_PPT.segmentDrivers,
    'Aura', 'AuraAndProgression', 'AuraAndComparison', 'AuraAndProgressionAndComparison', 'AuraWithoutSentiments', 'AuraWithoutSentimentsAndProgression', 'AuraWithoutSentimentsAndComparison', 'AuraWithoutSentimentsAndProgressionAndComparison'
  ]
  const isCustomImage = ['CustomImage'].includes(type) && ![ '9d0c623b-b2de-11ed-817c-0a1ea4c5532f', '5e95d366-6bf1-11ee-817c-0a1ea4c5532f', '63357b94-b2da-11ee-9f55-0a1ea4c5532f', '70a2369b-fafb-11ee-8482-128e718ba88f', 'ee0f401e-424d-11ef-8482-128e718ba88f', '2e0c6172-882b-11ef-8482-128e718ba88f', '00365fa2-53c5-4639-b6df-cd19d5961109', '2a887346-722b-11ef-8482-128e718ba88f' ].includes(insightsId)
  const showChildren = isCSVModalActive || (isPPTModalActive && (array.includes(type) || isCustomImage));

  return (
    <OuterWrapper className='reportOuterWrapper' id={id} style={style}>
      {showChildren ? <>downloading..</> : children}
    </OuterWrapper>
  )
}

export default ReportOuterWrapper
